<!-- Comment Button (Each event has its own) -->
<div (click)="openCommentBox(data.data?.eventId)">
    <i class="bi bi-chat"></i>
    &nbsp;<span>{{data.data?.RatingSummary?.total ?? 0}}</span>
</div>

<!-- Comment Section (Visible only for active event) -->
<div *ngIf="activeEventId === data.data?.eventId" class="comment-container">
    <textarea [(ngModel)]="newComment" placeholder="Write a comment..."
        (keydown.enter)="postComment($event)" class="comment-box form-control"></textarea>
    <button (click)="postComment($event)" class="btn btn-primary mt-2">Post</button>

    <!-- Display Comments -->
    <div *ngFor="let comment of comments[data.data?.eventId]" class="comment-item mt-2">
        <p>{{ data.data?.ratings}}</p>
    </div>
</div>
